import angular from "angular";

angular
	.module('app')
	.component('quizResultPage', {
		template: require('./quiz-result-page.html'),
        controller: ['$http', controller],
        bindings: {
            questions: '<',
        }
    });
            
function controller($http) {
        
	let $ctrl = this;

	$ctrl.$onInit = function () {
	};

}